import React from 'react';
import './AboutMe.css';


const AboutMe = function () {
    return (
        <div id="about" className="about">
            <div className="space"/>

            <h2>
                ABOUT ME
            </h2>
            <div className="space"/>

            <div className="main d-flex flex-column flex-md-row px-2 px-sm-3">
                <div id="main-photo" className="flex-shrink-0 w-auto pb-0 pb-sm-2">
                    <img alt="Paola Valdivia" src="img/pao_small.png"/>
                </div>
                <div id="main-text" className="w-100 w-sm-75 pl-0 pl-sm-3 pt-3 pt-sm-0 flex-grow-1">
                    <span id="myname">Paola Valdivia</span>
                    <span>Research engineer</span>
                    <div id="info">
                        <a href="https://www.telecom-paris.fr/" target="_blank" rel="noopener noreferrer">Télécom
                            Paris</a>  &nbsp;&nbsp; & &nbsp;&nbsp;
                        <a href="http://www.aviz.fr" target="_blank" rel="noopener noreferrer">Aviz</a> -
                        <a href="http://www.inria.fr" target="_blank" rel="noopener noreferrer">INRIA</a>
                        <div className="contacttext">
                            paola.valdivia@inria.fr
                        </div>
                    </div>

                    <div className="space-lg"/>
                    <div className="justified">
                        I am a researcher in the field of visual analytics, a practice that brings together data
                        analysis,
                        information visualization, HCI methods and software development.
                    </div>
                </div>
            </div>
            <div className="space"/>


            <div>
                <div className="d-flex flex-md-row flex-wrap justify-content-center">
                    <div className="px-1 technology"> information visualization</div>
                    <div className="px-1 technology"> visual analytics</div>
                    <div className="px-1 technology"> network visualization</div>
                </div>
            </div>
            <div className="space"/>

            <div className="links">
                {/*<p className="links"> <a href="http://lattes.cnpq.br/6396583258478990">*/}
                {/*<img alt="Lattes" src="img/lattes.png" className="icon" />  CV Lattes </a>*/}
                <a itemProp="sameAs" content="https://orcid.org/0000-0002-8627-1316"
                   href="https://orcid.org/0000-0002-8627-1316" target="orcid.widget" rel="noopener noreferrer">
                    <img src="img/orcid.png" alt="ORCID iD icon" className="icon"/>
                    <span className="d-none d-sm-inline">ORCID ID</span>
                </a>
                &nbsp;&nbsp;&nbsp;
                <a className="align-content-center align-middle" href="http://br.linkedin.com/in/paolavaldivia">
                    <img alt="LinkedIn" src="img/linked.png" className="icon"/>
                    <span className="d-none d-sm-inline">LinkedIn</span>
                </a>
                &nbsp;&nbsp;&nbsp;
                <a href="https://scholar.google.fr/citations?user=cHH8IJYAAAAJ&hl=en">
                    <img alt="Google Scholar" src="img/googlescholar.png" className="icon"/>
                    <span className="d-none d-sm-inline">    Google Scholar</span>
                </a>
                &nbsp;&nbsp;&nbsp;
                <a href="https://github.com/paolavaldivia">
                    <img alt="GitHub" src="img/github.png" className="icon"/>
                    <span className="d-none d-sm-inline"> GitHub </span>
                </a>
                &nbsp;&nbsp;&nbsp;
                <a href="files/PaolaValdivia_CV.pdf">
                    <img alt="CV" src="img/curriculum-vitae.png" className="icon"/>
                    <span className="d-none d-sm-inline"> CV </span>
                </a>
            </div>

            <div className="space-lg"></div>

        </div>
    );
}

export default AboutMe;



// WEBPACK FOOTER //
// ./src/AboutMe/AboutMe.js